import React, { lazy } from "react";
import { RouteObject } from "react-router-dom";

const HomePage = lazy(() => import("../pages/home/page"));
const NotFound = lazy(() => import("../pages/NotFound"));
const LoginPage = lazy(() => import("../pages/private/LoginPage"));
const PrivateGalleryPage = lazy(() => import("../pages/private/PrivateGalleryPage"));
const BalsaGalleryPage = lazy(() => import("../pages/private/BalsaGalleryPage"));
const AdminPhotosPage = lazy(() => import("../pages/admin/AdminPhotosPage"));
const AdminBalsaPage = lazy(() => import("../pages/admin/AdminBalsaPage"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/acceso",
    element: <LoginPage />,
  },
  {
    path: "/admin/login",
    // Explicitly pass a boolean prop to avoid JSX parsing ambiguities
    element: <LoginPage isAdminLogin={true} />,
  },
  {
    path: "/private/gallery",
    element: <PrivateGalleryPage />,
  },
  {
    path: "/private/balsa-gallery",
    element: <BalsaGalleryPage />,
  },
  {
    path: "/admin/photos",
    element: <AdminPhotosPage />,
  },
  {
    path: "/admin/balsa",
    element: <AdminBalsaPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
